import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import './styles.css'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'

import { theme } from './theme'
import { Auth, ForgotPassword, ResetPassword,  } from './Auth'

export const App = () => {
  return (
    <BrowserRouter>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<Auth />} />
          <Route path="/login" element={<Navigate replace to="/" />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:hash/:email" element={<ResetPassword />} />
          <Route path="/logout" element={<Auth logout />} />
          {/* <Route path="/NotFound" element={<NotFound />} />
          <Route path="/:url" element={<Auth />} /> */}
          <Route path="*" element={<Auth />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  )
}